import { FeatureFlags } from '../FeatureFlags';
import { Filter } from '../helpers/Filter';
import { Order } from '../helpers/Order';
import { FlowBaseInfo } from '../models/FlowInfo';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IViewBase } from '../models/IViewInfo';
import { IWorkbookBase } from '../models/IWorkbookInfo';
import { Module } from '../Module';
import { AddFavoriteRequest } from '../ServerApi/requests/AddFavoriteRequest';
import { GetFavoritesRequest, IGetFavoritesResult } from '../ServerApi/requests/GetFavoritesRequest';
import { RemoveFavoriteRequest } from '../ServerApi/requests/RemoveFavoriteRequest';
import { ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { FavoriteKeys, IFavorite } from '../ServerApi/types/IFavorite';
import { IOrderClause } from '../ServerApi/types/IOrderClause';
import { IResult } from '../ServerApi/types/IResponse';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { Resource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class Favorites extends Resource<IFavorite> {

  public static $inject = ['ServerService', 'FetcherFactory'];

  constructor(private server: ServerService, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetFavoritesRequest,
      (result: IGetFavoritesResult) => result.favorites));
  }

  public all(): ResourceQuery<IFavorite> {
    let query: ResourceQuery<IFavorite> = super.all();
    let targetTypes: string[] =  ['WORKBOOK', 'DATASOURCE', 'PROJECT', 'VIEW', 'DATAROLE'];

    if (this.server.flowsOnSiteEnabled()) {
      targetTypes.push('FLOW');
    }

    if (FeatureFlags.metricsSpaceEnabled) {
      targetTypes.push('METRIC');
    }

    return query.addFilter(Filter.stringFieldInArray('targetType', targetTypes));
  }

  public allForTypesAndSort(targetType: string, order: IOrderClause): ResourceQuery<IFavorite> {
    return super.all().withOrder([order])
      .addFilter(Filter.stringFieldInArray('targetType', [targetType]));
  }

  public addView(view: IViewBase): ng.IPromise<IResult> {
    return this.add(view.id, 'view');
  }

  public addWorkbook(workbook: IWorkbookBase): ng.IPromise<IResult> {
    return this.add(workbook.id, 'workbook');
  }

  public addDatasource(datasource: IDataSourceBase): ng.IPromise<IResult> {
    return this.add(datasource.idForFavoriting, 'datasource');
  }

  public addFlow(flow: FlowBaseInfo): ng.IPromise<IResult> {
    return this.add(flow.id, 'flow');
  }

  public removeView(view: IViewBase): ng.IPromise<IResult> {
    return this.remove(view.id, 'view');
  }

  public removeViewById(id: string): ng.IPromise<IResult> {
    return this.remove(id, 'view');
  }

  public removeWorkbook(workbook: IWorkbookBase): ng.IPromise<IResult> {
    return this.remove(workbook.id, 'workbook');
  }

  public removeDatasource(datasource: IDataSourceBase): ng.IPromise<IResult> {
    return this.remove(datasource.idForFavoriting, 'datasource');
  }

  public removeFlow(flow: FlowBaseInfo): ng.IPromise<IResult> {
    return this.remove(flow.id, 'flow');
  }

  public add(objectId: string, objectType: ExploreContentApi_ContentType): ng.IPromise<IResult> {
    return this.server.sendRequest(new AddFavoriteRequest({
      objectId: objectId,
      objectType: objectType
    }));
  }

  public remove(objectId: string, objectType: ExploreContentApi_ContentType): ng.IPromise<IResult> {
    return this.server.sendRequest(new RemoveFavoriteRequest({
      objectId: objectId,
      objectType: objectType
    }));
  }

}

Module.instance().service('Favorites', Favorites);
